import React, { Component } from "react";
import Autosuggest from "react-autosuggest";
import "./style.css";

class Input extends Component {
  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(event) {
    event.preventDefault();
    this.suggest.input.blur();
    this.props.handleSubmit();
  }

  getSuggestionValue = suggestion => suggestion.name;

  renderSuggestion = suggestion => <div>{suggestion.name}</div>;

  render() {
    const inputProps = {
      placeholder: this.props.placeholder,
      value: this.props.value,
      onChange: this.props.onChange,
      onClick: this.props.onClick
    };

    return (
      <form className="input" onSubmit={this.onSubmit}>
        <div className="input__input">
          <Autosuggest
            ref={(elem) => { this.suggest = elem; }}
            suggestions={this.props.suggestions}
            onSuggestionsFetchRequested={this.props.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.props.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            inputProps={inputProps}
          />
        </div>
      </form>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/scenes/Location/components/Input/index.js